module.exports = __webpack_public_path__ + "img/sstz_bg.f7f97398.jpg";